import React from "react";
import Modal from "components/Modals/index";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Typography, Box, Stack, Button } from "@mui/material";

function RemoveSuccessModal({ isOpen, handleClose, removeSeats }) {
  return (
    <Modal isOpen={isOpen} handleClose={handleClose} title="Seat(s) Removed">
      <Box
        sx={theme => ({
          background: theme.palette.text.dark.primary,
          padding: "20px",
          borderRadius: "8px",
          [theme.breakpoints.down("sm")]: {
            background: theme.palette.background.default
          }
        })}
      >
        <Stack direction="row" alignItems="center">
          <CheckCircleIcon color="primary" />
          <Typography variant="h6" color="text.primary" margin="0 16px">
            {removeSeats.removeSeats}
          </Typography>
          <Typography variant="body1" color="text.primary">
            seat(s)
          </Typography>
        </Stack>
      </Box>
      <Stack direction="row" marginTop="32px" flexWrap="wrap">
        <Button
          color="primary"
          variant="contained"
          onClick={handleClose}
          sx={theme => ({
            [theme.breakpoints.down("sm")]: {
              width: "100%"
            }
          })}
        >
          CONTINUE
        </Button>
      </Stack>
    </Modal>
  );
}

export default RemoveSuccessModal;
